import { LevelDesignerElementBase } from '../element-base';
import { PolygonElement } from '../polygon-element';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ParkingLevelElement } from './parkinglevel';
import { ParkingSpaceElement } from './parkingspace';
import { PropertyMetadata } from '../../properties/property-types';
import { RegisterElement } from '../element-decorator';
import { v4 as uuidv4 } from 'uuid';

@RegisterElement()
export class ParkingRowElement extends PolygonElement {
    layerIndex: number = 1;
    public override TypeName: string = "ParkingRow";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "Rows";
    protected override OutlineColor: string = '#e74c3c';
    protected override FillColor: string = 'rgba(231, 76, 60, 0.2)';
    

    constructor(formGroup: FormGroup) {
        super(formGroup);
        
        // Ensure all required form controls exist
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('Spaces')) {
            formGroup.addControl('Spaces', new FormArray([])); 
        }
       
    }

    override clone(): ParkingRowElement {
        return new ParkingRowElement(this.formGroup);
    }

    override default(): ParkingRowElement {
        this.points = [
            { x: 0, y: 0 },
            { x: 10, y: 0 },
            { x: 10, y: 10 },
            { x: 0, y: 10 }
        ];
        this.formGroup.patchValue({
            Id: uuidv4(),
            Name: '',
            PolygonPoints: this.points.map(p => [p.x / 1000, p.y / 1000]),
        });
        return this;
    }

    

    override updateForm(): void {
        super.updateForm();
    }

    public addSpace(space: ParkingSpaceElement): void {
        const spacesArray = this.formGroup.get('Spaces') as FormArray;
        spacesArray.push(space.formGroup);
        this.formGroup.markAsDirty();
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Row Name',
                inputType: { type: 'text' },
                description: 'Identifier for this parking row',
                order: 1,
                category: 'General'
            },
            {
                displayName: 'Width',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 2,
                category: 'Dimensions',
                getValue: (element) => element.getWidth(),
                setValue: (element, value) => element.setWidth(value)
            },
            {
                displayName: 'Length',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 3,
                category: 'Dimensions',
                getValue: (element) => element.getHeight(),
                setValue: (element, value) => element.setHeight(value)
            }
        ];
    }
}
